import React from 'react';
import { users } from 'types';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import useUserSuspend from '../hooks/use-user-suspend';
import DialogForm from 'components/dialog/dialog-form';
import AppFormikInput from 'components/form/formik/input/input';

type TValues = {
    reason: string;
};

const DialogSuspend = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data?: users.TUsersDetail } & TDialogWrapperComponent) => {
    const [onSuspend, { isLoading }] = useUserSuspend(asyncStatesHandlers);

    if (!data || !data.id) {
        console.error('No ID');
    }

    const initValues: TValues = {
        reason: '',
    };

    return (
        <DialogForm<TValues>
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Confirm User Suspend'}
            onSubmit={async (values) => {
                const payload = {
                    id: data.id,
                    ...values,
                };
                await onSuspend(payload);
            }}
            isLoading={isLoading}
            initValues={initValues}
            validate={(values) => {
                let errors: Partial<TValues> = {};

                if (values.reason.length === 0) {
                    errors.reason = 'Required';
                }

                return errors;
            }}
        >
            <AppFormikInput name={'reason'} placeholder={'Suspension reason'} />
        </DialogForm>
    );
};

export default DialogSuspend;
